import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './features/userSlice';
import { lightDarkSlice } from './features/lightDarkSlice';
import weAllTeamReducer from './features/weAllTeamSlice';

// Configuration for redux-persist to set up storage and blacklist
const persistConfig = {
  key: 'suitme_admin', // Key to store the persisted data
  storage, // Storage method (localStorage by default)
  blacklist: ['weall_team'], // Live unread count: never persisted, re-read on every load
  debug: true, // Enable debug mode to see persist actions
};

// Combine all reducers (user and theme reducers) into one rootReducer
const rootReducer = combineReducers({
  user: userReducer, // User data slice reducer
  admin_theme: lightDarkSlice, // Admin theme slice reducer (light/dark mode)
  weall_team: weAllTeamReducer // WeAll Team inbox unread count (sidebar badge)
});

// Apply persistReducer to persist state across sessions
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Redux store with persistedReducer
const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer to enable state persistence
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for react-query compatibility
    }),
  devTools: { trace: true, traceLimit: 25 }, // Enable Redux DevTools with trace options
});


// Initialize persistStore to manage persisting of the store
let persistor = persistStore(store);

// Export store and persistor for use in the app
export { persistor, store };
